/**
 * DAILY NATURE — Gratis-Zugaben im Warenkorb, kumulativ gestaffelt
 *
 * Ab 39 Euro kommt die Basis-Zugabe automatisch dazu, ab 49 Euro bleibt sie drin und
 * der Kunde waehlt eine zweite. Es sind dann zwei Produkte gratis, nicht eins.
 *
 * Die Rabatte macht Shopify: zwei automatische BxGy mit Mindest-KAUFBETRAG, einer ab
 * 39 Euro fuer eine Einheit, einer ab 49 Euro fuer zwei. Sie greifen nie gleichzeitig,
 * die Plattform nimmt den fuer den Kunden besseren. Der Preis eines Ritual-Sets zaehlt
 * auf eine Betragsbedingung mit, anders als auf eine Mengenbedingung.
 *
 * Dieses Skript legt Zugaben nur in den Warenkorb und nimmt sie wieder heraus. Preise
 * und Summen rechnet es nicht um, Shopify wendet die Rabatte bereits im Warenkorb an.
 */
(function () {
  'use strict';

  var busy = false;

  function post(url, body) {
    return fetch(Shopify.routes.root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error(url + ' ' + res.status);
      return res.json();
    });
  }

  // Immer frisch laden: die Ereignis-Nutzlast des Themes fuehrt keine Line-Properties.
  function getCart() {
    return fetch(Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); });
  }

  function announce() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function isGiftLine(line) {
    return !!(line.properties && line.properties._dn_gift);
  }

  function removeLines(keys) {
    var updates = {};
    keys.forEach(function (key) { updates[key] = 0; });
    return post('cart/update.js', { updates: updates });
  }

  function baseVariantId() {
    var el = document.querySelector('[data-dn-gift]');
    return el ? parseInt(el.dataset.baseVariant, 10) : 0;
  }

  /** Waehlt die zweite Zugabe. Die Basis-Zugabe bleibt unangetastet. */
  function choose(variantId) {
    if (busy) return;
    busy = true;
    var base = baseVariantId();
    getCart()
      .then(function (cart) {
        var alt = cart.items
          .filter(function (l) { return isGiftLine(l) && l.variant_id !== base; })
          .map(function (l) { return l.key; });
        return alt.length ? removeLines(alt) : null;
      })
      .then(function () {
        return post('cart/add.js', {
          items: [{ id: variantId, quantity: 1, properties: { _dn_gift: 'ja' } }]
        });
      })
      .then(function () { busy = false; announce(); })
      .catch(function () { busy = false; announce(); });
  }

  /** Legt die Basis-Zugabe von selbst in den Warenkorb, sobald die Schwelle faellt. */
  function addBase() {
    var el = document.querySelector('[data-dn-gift]');
    if (!el || el.dataset.baseOpen !== 'true') return Promise.resolve();
    var base = baseVariantId();
    if (!base) return Promise.resolve();

    return getCart().then(function (cart) {
      var da = cart.items.some(function (l) { return isGiftLine(l) && l.variant_id === base; });
      if (da) return;
      return post('cart/add.js', {
        items: [{ id: base, quantity: 1, properties: { _dn_gift: 'ja' } }]
      }).then(announce);
    });
  }

  /**
   * Sicherung, und zugleich die gesamte Schwellenlogik.
   *
   * Eine als Zugabe markierte Zeile darf nur im Warenkorb bleiben, wenn sie
   * tatsaechlich nichts kostet. Damit ist der Rabatt die alleinige Autoritaet: faellt
   * der Warenkorb unter die Schwelle, greift er nicht mehr, die Zeile kostet wieder
   * Geld und fliegt hier heraus. Dasselbe gilt, wenn der Rabatt pausiert, abgelaufen
   * oder falsch konfiguriert ist. Der Fehlerfall wird sichtbar, statt auf der Rechnung
   * zu landen, und das Theme muss die Schwellen nicht doppelt nachbilden.
   */
  function reconcile() {
    if (!document.querySelector('[data-dn-gift]')) return Promise.resolve();

    return getCart().then(function (cart) {
      var streichen = cart.items
        .filter(function (line) { return isGiftLine(line) && line.final_line_price > 0; })
        .map(function (line) { return line.key; });
      if (!streichen.length) return;

      return removeLines(streichen).then(announce);
    });
  }

  /** Reihenfolge zaehlt: erst aufraeumen, dann die Basis-Zugabe nachlegen. */
  function sync() {
    if (busy) return;
    busy = true;
    reconcile()
      .then(addBase)
      .then(function () { busy = false; })
      .catch(function () { busy = false; });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-dn-gift-option]');
    if (!button || button.disabled) return;
    event.preventDefault();
    if (button.classList.contains('is-chosen')) return;
    var id = parseInt(button.dataset.variantId, 10);
    if (!id) return;
    button.classList.add('is-busy');
    choose(id);
  });

  document.addEventListener('cart:refresh', sync);
  document.addEventListener('cart:change', sync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
